import React from 'react';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { t, isTranslated } from '../../../../../utils/i18n';
import { Description } from './elements';
import { MoreInfoModal } from '../elements';
import { DH } from '../../../../../utils/DataHook';
import { DeviceType } from '../../../../../types/DeviceType';

export interface StaticInstallmentsDescriptionViewProps {
  deviceType?: DeviceType;
  methodName: PaymentMethod;
  amount: string;
  currency: string;
  isInfoModalOpen?: boolean;
  onMoreInfoClick(): void;
  onCloseModal(): void;
  moreInfo: React.ReactNode;
  moreInfoSize?: {
    width: number | string;
    height: number | string;
  };
  isSinglePaymentMethodOption?: boolean;
}

export class StaticInstallmentsDescriptionView extends React.Component<StaticInstallmentsDescriptionViewProps> {
  renderMoreInfoModal = () => {
    const { moreInfo, moreInfoSize, deviceType, onCloseModal } = this.props;

    if (!moreInfo) {
      return null;
    }

    return (
      <MoreInfoModal
        dataHook={DH.PaymentMethod.Wallet.MoreInfoModal}
        deviceType={deviceType}
        width={moreInfoSize?.width}
        height={moreInfoSize?.height}
        onClose={onCloseModal}
      >
        {moreInfo}
      </MoreInfoModal>
    );
  };

  render() {
    const {
      amount,
      currency,
      methodName,
      onMoreInfoClick,
      isSinglePaymentMethodOption,
    } = this.props;

    const title = t(`wallet.description.${methodName}.title`, {
      amount,
      currency,
    });
    const subtitleKey = `wallet.description.${methodName}.subtitle`;
    const subtitle = isTranslated(subtitleKey) ? t(subtitleKey) : '';

    return (
      <div data-hook={DH.PaymentMethod.Wallet.StaticInstallment.Root}>
        <Description
          title={title}
          subtitle={subtitle}
          moreInfoLabel={t(`wallet.description.${methodName}.moreInfo`)}
          onMoreInfoClick={onMoreInfoClick}
          isSinglePaymentMethodOption={isSinglePaymentMethodOption}
        />
        {this.props.isInfoModalOpen && this.renderMoreInfoModal()}
      </div>
    );
  }
}
